module.exports = __webpack_public_path__ + "img/support_agent-24px.49459a38.svg";